export const hasWebview2 = (): boolean => !!window?.chrome?.webview
